/**
 * Safely converts a value to an integer, returning a fallback if conversion fails
 * @param value - Value to convert to integer
 * @param fallback - Fallback value if conversion fails
 * @returns Converted integer or fallback
 */
export const toInt = (value: any, fallback: number): number => {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};
